import { createFileRoute } from '@tanstack/react-router'
import { LabelAssignPage } from '../../components/labels/LabelAssignPage'

// "Stick first, assign by scanning" (spec 2026-08-17-03).
//
// Inside routes/$org, so it inherits the auth guard: the public scan page
// deliberately refuses to confirm that an unassigned code exists, and this is
// where a signed-in field tech lands instead.
export const Route = createFileRoute('/$org/labels/$code')({
    component: LabelAssignRoute,
})

function LabelAssignRoute() {
    const { org, code } = Route.useParams()

    return <LabelAssignPage org={org} code={code} />
}
